<template>
	<div>
		<userMenu></userMenu>
		<div class="nov-wrap">
			<div class="nov-main">
				<h2>网文热度前 50 书单（2026.8）</h2>
				<h3>一、长青现象级神作</h3>
				<div class="nov-item" v-for="(item,index) in list" v-if="index<15">
					<div class="nov-item-top">
						<div class="nov-no">
							{{index+1<10?'0'+(index+1):index+1}}
						</div>
						<div class="nov-bkname">
							<a :href="item.lk" target="_blank">{{item.bookName}}</a>
						</div>
						<div class="nov-bkval">
							{{item.hotValue}}
							<i class="el-icon-top"></i>
						</div>
					</div>
					<div class="nov-item-bto">
						<div class="nov-item-tag">
							{{item.author}} · {{item.platform}} · {{item.category}}
						</div>
						<div class="nov-item-hot">
							热度
						</div>
					</div>
				</div>
				<h3>二、男频热门连载 & 高热度完结爽文</h3>
				<div class="nov-item" v-for="(item,index) in list" v-if="14<index&&index<32">
					<div class="nov-item-top">
						<div class="nov-no">
							{{index+1<10?'0'+(index+1):index+1}}
						</div>
						<div class="nov-bkname">
							{{item.bookName}}
						</div>
						<div class="nov-bkval">
							{{item.hotValue}}
							<i class="el-icon-top"></i>
						</div>
					</div>
					<div class="nov-item-bto">
						<div class="nov-item-tag">
							{{item.author}} · {{item.platform}} · {{item.category}}
						</div>
						<div class="nov-item-hot">
							热度
						</div>
					</div>
				</div>
				<h3>三、女频全网高热度作品（言情 / 大女主 / 无限流）</h3>
				<div class="nov-item" v-for="(item,index) in list" v-if="index>31">
					<div class="nov-item-top">
						<div class="nov-no">
							{{index+1<10?'0'+(index+1):index+1}}
						</div>
						<div class="nov-bkname">
							{{item.bookName}}
						</div>
						<div class="nov-bkval">
							{{item.hotValue}}
							<i class="el-icon-top"></i>
						</div>
					</div>
					<div class="nov-item-bto">
						<div class="nov-item-tag">
							{{item.author}} · {{item.platform}} · {{item.category}}
						</div>
						<div class="nov-item-hot">
							热度
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import userMenu from '@/page/public/userMenu'
	import api from '@/api/api'
	export default {
		components: {
			userMenu: userMenu
		},
		data() {
			return {
				list: [{
						"rank": 1,
						"bookName": "诡秘之主",
						"author": "爱潜水的乌贼",
						"platform": "起点中文网",
						"category": "克苏鲁蒸汽玄幻",
						"label": "长青经典顶流",
						"hotValue": 999173,
						"lk":"http://www.100liy.com/read/detail.html?id=583"
					},
					{
						"rank": 2,
						"bookName": "道诡异仙",
						"author": "狐尾的笔",
						"platform": "起点中文网",
						"category": "中式克苏鲁修仙",
						"label": "长青经典顶流",
						"hotValue": 986241
					},
					{
						"rank": 3,
						"bookName": "我在精神病院学斩神",
						"author": "三九音域",
						"platform": "番茄小说",
						"category": "都市神明",
						"label": "长青经典顶流",
						"hotValue": 973562
					},
					{
						"rank": 4,
						"bookName": "十日终焉",
						"author": "杀虫队队员",
						"platform": "番茄小说",
						"category": "规则怪谈无限流",
						"label": "长青经典顶流",
						"hotValue": 961037
					},
					{
						"rank": 5,
						"bookName": "神秘复苏",
						"author": "佛前献花",
						"platform": "起点中文网",
						"category": "灵异惊悚",
						"label": "长青经典顶流",
						"hotValue": 948625
					},
					{
						"rank": 6,
						"bookName": "剑来",
						"author": "烽火戏诸侯",
						"platform": "起点中文网",
						"category": "古典仙侠",
						"label": "长青经典顶流",
						"hotValue": 935147
					},
					{
						"rank": 7,
						"bookName": "万族之劫",
						"author": "老鹰吃小鸡",
						"platform": "起点中文网",
						"category": "都市异能",
						"label": "长青经典顶流",
						"hotValue": 922784
					},
					{
						"rank": 8,
						"bookName": "赤心巡天",
						"author": "情何以甚",
						"platform": "起点中文网",
						"category": "古典仙侠",
						"label": "长青经典顶流",
						"hotValue": 910369
					},
					{
						"rank": 9,
						"bookName": "我师兄实在太稳健了",
						"author": "言归正传",
						"platform": "起点中文网",
						"category": "洪荒修仙",
						"label": "长青经典顶流",
						"hotValue": 897416
					},
					{
						"rank": 10,
						"bookName": "夜的命名术",
						"author": "会说话的肘子",
						"platform": "起点中文网",
						"category": "都市异能",
						"label": "长青经典顶流",
						"hotValue": 884923
					},
					{
						"rank": 11,
						"bookName": "长夜余火",
						"author": "爱潜水的乌贼",
						"platform": "起点中文网",
						"category": "废土科幻",
						"label": "长青经典顶流",
						"hotValue": 871658
					},
					{
						"rank": 12,
						"bookName": "玄鉴仙族",
						"author": "季越人",
						"platform": "起点中文网",
						"category": "家族修仙",
						"label": "长青经典顶流",
						"hotValue": 859371
					},
					{
						"rank": 13,
						"bookName": "捞尸人",
						"author": "纯洁滴小龙",
						"platform": "起点中文网",
						"category": "民俗悬疑",
						"label": "长青经典顶流",
						"hotValue": 846295
					},
					{
						"rank": 14,
						"bookName": "元尊",
						"author": "天蚕土豆",
						"platform": "起点中文网",
						"category": "东方玄幻",
						"label": "长青经典顶流",
						"hotValue": 833742
					},
					{
						"rank": 15,
						"bookName": "凡人修仙传",
						"author": "忘语",
						"platform": "起点中文网",
						"category": "凡人流修仙",
						"label": "长青经典顶流",
						"hotValue": 820634
					},
					{
						"rank": 16,
						"bookName": "清光宝鉴",
						"author": "一片苏叶",
						"platform": "起点中文网",
						"category": "古典仙侠",
						"label": "男频热门新作",
						"hotValue": 807926
					},
					{
						"rank": 17,
						"bookName": "秩序游戏",
						"author": "南月知清",
						"platform": "起点中文网",
						"category": "悬疑幻想",
						"label": "男频热门新作",
						"hotValue": 795183
					},
					{
						"rank": 18,
						"bookName": "开局掌控魏忠贤",
						"author": "",
						"platform": "起点中文网",
						"category": "明末历史爽文",
						"label": "男频热门新作",
						"hotValue": 782461
					},
					{
						"rank": 19,
						"bookName": "1984：从破产川菜馆开始",
						"author": "轻语江湖",
						"platform": "起点中文网",
						"category": "年代商战",
						"label": "男频热门新作",
						"hotValue": 769837
					},
					{
						"rank": 20,
						"bookName": "天眼风水师",
						"author": "",
						"platform": "番茄小说",
						"category": "都市玄学",
						"label": "男频热门新作",
						"hotValue": 757129
					},
					{
						"rank": 21,
						"bookName": "盖世神医",
						"author": "狐颜乱语",
						"platform": "七猫免费小说",
						"category": "都市神医",
						"label": "男频热门新作",
						"hotValue": 744692
					},
					{
						"rank": 22,
						"bookName": "荒古武神",
						"author": "化十",
						"platform": "七猫免费小说",
						"category": "东方玄幻",
						"label": "男频热门新作",
						"hotValue": 731846
					},
					{
						"rank": 23,
						"bookName": "诸神愚戏",
						"author": "一月九十秋",
						"platform": "番茄小说",
						"category": "克苏鲁无限流",
						"label": "男频热门新作",
						"hotValue": 719374
					},
					{
						"rank": 24,
						"bookName": "牧牛长生录",
						"author": "",
						"platform": "起点中文网",
						"category": "底层写实修仙",
						"label": "男频热门新作",
						"hotValue": 706815
					},
					{
						"rank": 25,
						"bookName": "朝堂混世魔",
						"author": "",
						"platform": "起点中文网",
						"category": "历史权谋",
						"label": "男频热门新作",
						"hotValue": 694273
					},
					{
						"rank": 26,
						"bookName": "郭鹏",
						"author": "贼眉鼠眼",
						"platform": "起点中文网",
						"category": "汉末历史",
						"label": "男频热门新作",
						"hotValue": 681536
					},
					{
						"rank": 27,
						"bookName": "我只想安静的做个苟道中人",
						"author": "爆炸小拿铁",
						"platform": "起点中文网",
						"category": "苟道修仙",
						"label": "男频热门新作",
						"hotValue": 668947
					},
					{
						"rank": 28,
						"bookName": "全班同学拜大宗师，我拜菩提祖师",
						"author": "",
						"platform": "番茄小说",
						"category": "脑洞玄幻",
						"label": "男频热门新作",
						"hotValue": 656312
					},
					{
						"rank": 29,
						"bookName": "山野诡闻笔记",
						"author": "吴大胆",
						"platform": "七猫免费小说",
						"category": "乡土灵异",
						"label": "男频热门新作",
						"hotValue": 643781
					},
					{
						"rank": 30,
						"bookName": "鉴宝：我能从文物中提取技能",
						"author": "最爱老板娘",
						"platform": "七猫免费小说",
						"category": "都市鉴宝",
						"label": "男频热门新作",
						"hotValue": 631247
					},
					{
						"rank": 31,
						"bookName": "让你冒充太子，你咋登基了？",
						"author": "张正经",
						"platform": "七猫免费小说",
						"category": "穿越权谋",
						"label": "男频热门新作",
						"hotValue": 618693
					},
					{
						"rank": 32,
						"bookName": "吞天神体",
						"author": "化十",
						"platform": "七猫免费小说",
						"category": "东方玄幻",
						"label": "男频热门新作",
						"hotValue": 606175
					},
					{
						"rank": 33,
						"bookName": "偷偷藏不住",
						"author": "竹已",
						"platform": "晋江文学城",
						"category": "现代言情",
						"label": "女频热门新作",
						"hotValue": 593624
					},
					{
						"rank": 34,
						"bookName": "偏偏宠爱",
						"author": "藤萝为枝",
						"platform": "晋江文学城",
						"category": "校园言情",
						"label": "女频热门新作",
						"hotValue": 581072
					},
					{
						"rank": 35,
						"bookName": "错撩",
						"author": "翘摇",
						"platform": "晋江文学城",
						"category": "都市现言",
						"label": "女频热门新作",
						"hotValue": 568539
					},
					{
						"rank": 36,
						"bookName": "小叔抱我",
						"author": "书中自有颜如玉",
						"platform": "番茄小说",
						"category": "豪门言情",
						"label": "女频热门新作",
						"hotValue": 556017
					},
					{
						"rank": 37,
						"bookName": "久慕年深",
						"author": "温知予",
						"platform": "番茄小说",
						"category": "暗恋豪门言情",
						"label": "女频热门新作",
						"hotValue": 543482
					},
					{
						"rank": 38,
						"bookName": "封总，太太想跟你离婚很久了",
						"author": "云中觅",
						"platform": "七猫免费小说",
						"category": "追妻火葬场",
						"label": "女频热门新作",
						"hotValue": 530946
					},
					{
						"rank": 39,
						"bookName": "离婚后她惊艳了世界",
						"author": "明婳",
						"platform": "七猫免费小说",
						"category": "重生大女主",
						"label": "女频热门新作",
						"hotValue": 518391
					},
					{
						"rank": 40,
						"bookName": "凤池生春",
						"author": "秦安安",
						"platform": "七猫免费小说",
						"category": "古言宅斗",
						"label": "女频热门新作",
						"hotValue": 505873
					},
					{
						"rank": 41,
						"bookName": "大理有晴天",
						"author": "池陌",
						"platform": "晋江文学城",
						"category": "治愈都市言情",
						"label": "女频热门新作",
						"hotValue": 493328
					},
					{
						"rank": 42,
						"bookName": "灯花笑",
						"author": "",
						"platform": "晋江文学城",
						"category": "古言复仇大女主",
						"label": "女频热门新作",
						"hotValue": 480795
					},
					{
						"rank": 43,
						"bookName": "我在废土世界扫垃圾",
						"author": "有花在野",
						"platform": "晋江文学城",
						"category": "废土大女主",
						"label": "女频热门新作",
						"hotValue": 468261
					},
					{
						"rank": 44,
						"bookName": "祝逍遥",
						"author": "披萝的丑丑",
						"platform": "起点女生网",
						"category": "仙侠大女主",
						"label": "女频热门新作",
						"hotValue": 455727
					},
					{
						"rank": 45,
						"bookName": "重生八零：辣妻搞事业",
						"author": "",
						"platform": "番茄小说",
						"category": "年代重生言情",
						"label": "女频热门新作",
						"hotValue": 443184
					},
					{
						"rank": 46,
						"bookName": "首辅无嗣？小通房却一胎三宝",
						"author": "满地梨花雪",
						"platform": "七猫免费小说",
						"category": "古言种田",
						"label": "女频热门新作",
						"hotValue": 430659
					},
					{
						"rank": 47,
						"bookName": "不要在垃圾桶里捡男朋友",
						"author": "骑鲸南去",
						"platform": "晋江文学城",
						"category": "无限流纯爱",
						"label": "女频热门新作",
						"hotValue": 418126
					},
					{
						"rank": 48,
						"bookName": "全球高考",
						"author": "木苏里",
						"platform": "晋江文学城",
						"category": "无限流纯爱",
						"label": "女频热门新作",
						"hotValue": 405583
					},
					{
						"rank": 49,
						"bookName": "天官赐福",
						"author": "墨香铜臭",
						"platform": "晋江文学城",
						"category": "仙侠纯爱",
						"label": "女频热门新作",
						"hotValue": 393047
					},
					{
						"rank": 50,
						"bookName": "云边有个小卖部",
						"author": "张嘉佳",
						"platform": "出版网文",
						"category": "都市温情",
						"label": "女频热门新作",
						"hotValue": 380512
					}
				]
			}
		}
	}
</script>

<style>
	.nov-item-tag{
		flex: 1;
		padding-left: 30px;
	}
	.nov-item-hot{
		width: 100px;
		text-align: right;
		margin-right: 20px;
	}
	.nov-item-bto{
		display: flex;
		font-size: 12px;
	}
	.nov-bkval{
		font-size: 14px;
		color: #333;
	}
	.nov-bkval i{
		position: relative;
		top: 2px;
		color: #f60;
		font-size: 16px;
	}
	.nov-bkname{
		font-weight: bold;
		flex: 1;
	}
	.nov-no{
		position: relative;
		top: -2px;
		font-size: 19px;
		font-family: 'numfont';
		width: 30px;
		color: #ddd;
	}
	.nov-item-top{
		display: flex;
		line-height: 30px;
	}
	.nov-item{
		margin-bottom: 20px;
		padding-bottom: 20px;
		border-bottom: 1px solid var(--bg3);
	}

	.nov-main {
		width: 800px;
		min-height: 500px;
		background-color: #fff;
		margin: 20px auto;
		border-radius: 10px;
		padding: 40px 100px;
		box-sizing: border-box;
	}
	.nov-main h3{
		padding-top: 40px;
		padding-bottom: 20px;
	}

	.nov-wrap {
		display: flex;
		width: 100%;
		min-height: 100vh;
		padding-left: 220px;
		box-sizing: border-box;
		background-color: var(--bg3);
	}
</style>



// WEBPACK FOOTER //
// src/page/novel.vue